import type { WorkTaskListParams } from "./workApi.js";

export const workQueryKeys = {
  all: ["work"] as const,
  projects: (workspaceId: string) => ["work", "projects", workspaceId] as const,
  projectRoot: ["work", "project"] as const,
  project: (projectId: string) => ["work", "project", projectId] as const,
  tasksRoot: ["work", "tasks"] as const,
  tasks: (params: WorkTaskListParams) => [
    "work",
    "tasks",
    params.workspaceId ?? null,
    params.projectId ?? null,
    params.assignee ?? null,
    params.includeArchived ?? false,
    params.cursor ?? null,
    params.limit ?? 250,
  ] as const,
  task: (taskId: string) => ["work", "task", taskId] as const,
  taskScope: (taskId: string) => ["work", "task-scope", taskId] as const,
  comments: (taskId: string) => ["work", "comments", taskId] as const,
  activity: (taskId: string) => ["work", "activity", taskId] as const,
};
